import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TimelineLite, TweenLite} from "gsap";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TombOfAkhenatenTextStyles} from "../../config/TombOfAkhenatenTextStyles";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenGameModuleConfig} from "../../TombOfAkhenatenGameModuleConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";

export class BetWayWin implements GameRoundPresentation {

    private _gameData:TombOfAkhenatenParsedGameData;
    private _centerReel:number = 12;
    private _winText:PIXI.Text;
    private _waysText:PIXI.Text;
    private _winTextShadow: PIXI.Sprite;
    private _isFirstTime: boolean = true;
    private _firstTimeDelay: number = 1.25;
    private _hasWin: boolean = false;
    private _stopIndividualWinForAS:boolean=false;

    constructor() {
        EventHandler.addEventListener(this, "stopIndividualWinForAS", (event: GameEvent) => {
            this._stopIndividualWinForAS=event.params[0];
            if(event.params[0]){
                this.cleanup();
                if(this._winText){
                    this._winText.text="";
                }
                if(this._waysText){
                    this._waysText.text="";
                }
            }
        });
    }

    public prepare(data:ParsedServerData):void {
        this._gameData = <TombOfAkhenatenParsedGameData>data;
        this._hasWin = this._gameData.singleWin > 0 && !this._stopIndividualWinForAS;
    }

    public getAnimation():TimelineLite | null {
        if (!this._hasWin) {
            this.cleanup();
            return null;
        }

        // create items only once
        if (this._winTextShadow === undefined) {
            this.createItems();
        }

        const tl: TimelineLite = new TimelineLite();

        if(this._isFirstTime){
            tl.add(TweenLite.to(() => {}, this._firstTimeDelay, {}));
            this._isFirstTime = false;
        }

        tl.add([
            this.getWinSymbolAnimations(),
        ]);
        return tl;
    }

    private cleanup(): void {
        if(this._winTextShadow) {
            this._winTextShadow.visible = false;
        }
        if(this._winText){
            this._winText.visible = false;
        }
        if(this._waysText){
            this._waysText.visible = false;
        }
    }

    public abort(isActive:boolean, data:ParsedServerData):TimelineLite | null {
        let _this = this;
        this._isFirstTime = true;
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            for(let i:number = 0; i < _this._gameData.betWins.length; i++) {
                let evaluatedReelWinPositions:boolean[] = (_this._gameData.betWins[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
                for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                    TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal!);
                }
            }
        }, 0);
        this.cleanup();

        return tl;
    }

    private getWinSymbolAnimations():TimelineLite | null {
        let _this = this;
        const tl:TimelineLite = new TimelineLite();

        let dataLength:number = _this._gameData.betWins.length;

        for (let i: number = 0; i < dataLength; i++) {
            tl.add([
                this.getBetWaysToggleAnimation((_this._gameData.betWins[i] as IBetWayWinData))
            ]);
        }

        return tl;
    }

    private getBetWaysToggleAnimation(data: IBetWayWinData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let _this = this,
            amountText: number = data.multipliedAmount,
            waysWon: number = data.numberOfCombinations,
            midReels: number[] = [_this._centerReel - 2, _this._centerReel - 1, _this._centerReel, _this._centerReel + 1, _this._centerReel + 2],
            winningHasMidReels: number[] = [],
            closestReelForWinText: number,
            winTextPos: number[] = [];

        tl.add(() => {
            this.cleanup();
        });

        let gameRoundReelWinnigPositions:boolean[] = [];
        for(let i:number = 0; i < _this._gameData.betWins.length; i++) {
            let evaluatedReelWinPositions:boolean[] = (_this._gameData.betWins[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(!gameRoundReelWinnigPositions[j]) {
                    gameRoundReelWinnigPositions[j] = evaluatedReelWinPositions[j];
                }
            }
        }

        tl.add(() => {
            let evaluatedReelWinPositions:boolean[] = data.reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(evaluatedReelWinPositions[j]) {
                    if(midReels.indexOf(j) > -1) {
                        winningHasMidReels.push(j);
                    }
                    TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win!);
                }else{
                    //#116 semiDimmed other winning symbols
                    if(gameRoundReelWinnigPositions[j]){
                        TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!);
                    }
                }
            }

            closestReelForWinText = winningHasMidReels.reduce(function(prev, curr) {
                return (Math.abs(curr - _this._centerReel) < Math.abs(prev - _this._centerReel) ? curr : prev);
            });

            winTextPos = Helper.getSymbolPositionsOnReelArea(closestReelForWinText, 0);

            this._winText.text = amountText.toFixed(2);
            this._winText.position.set(winTextPos[0] + 5, (winTextPos[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2) - 20));
            this._winText.visible = true;

            if (waysWon === 1){
                this._waysText.text = Translation.translate(waysWon.toString() + " way");
            } else {
                this._waysText.text = Translation.translate(waysWon.toString() + " ways");
            }
            this._waysText.position.set(winTextPos[0], (winTextPos[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2) + 20));
            this._waysText.visible = true;

            this._winTextShadow.position.set(winTextPos[0] + 5, (winTextPos[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2)));
            this._winTextShadow.visible = true;
        });

        // need to add this empty tween so that the symbol set back to its normal state between the toggling.
        tl.add(TweenLite.to(() => {
            //blank tween
        }, 0.5, {}), 0.9);

        return tl;
    }

    private createItems(): void {
        const layer: ScalableLayer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.BET_WAYS.name);

        this._winTextShadow = new PIXI.Sprite(GameResources.getTextures("winAmountShadow")[0]);
        this._winTextShadow.name="winTextShadow";
        this._winTextShadow.visible = false;
        this._winTextShadow.anchor.set(0.5);
        this._winTextShadow.scale.set(0.45, 0.75);

        this._winText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        this._winText.name="winText";
        this._winText.visible = false;
        this._winText.anchor.set(0.5);
        this._winText.scale.set(0.9);

        this._waysText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        this._waysText.name="waysText";
        this._waysText.visible = false;
        this._waysText.anchor.set(0.5);
        this._waysText.scale.set(0.4);

        layer.addChild(this._winTextShadow, this._winText, this._waysText);
    }
}